module.exports = __webpack_public_path__ + "img/Support-skill-217.7979af48.png";